<template>
    <v-dialog
        transition="dialog-bottom-transition"
        max-width="520"
        v-model="isShow"
    >
        <v-card class="pa-0 pb-6">
            <v-toolbar color="primary" dark class="text-h4">
                {{ dialogTitle }}
            </v-toolbar>

            <v-card-text class="pt-5 fs-14">
                {{ dialogText }}
            </v-card-text>

            <v-card-actions class="justify-center">
                <v-btn
                    color="primary"
                    class="text-white mr-4"
                    :loading="isSaving"
                    :disabled="isSaving"
                    @click="confirm"
                >
                    {{ confirmLabel }}
                </v-btn>
                <v-btn @click="closeDialog">
                    Скасувати
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
    name: "ReportsAckFollowupDialog",
    props: {
        isShowDialog: { type: Boolean, default: false },
        reportId: { type: [Number, String], default: null },
        mode: { type: String, default: null },
    },
    data() {
        return {
            isShow: false,
            isSaving: false,
        };
    },
    computed: {
        ...mapGetters({
            report: "ReportsModule/getReport",
        }),
        targetReportId() {
            return this.reportId || (this.report && this.report.id);
        },
        isClearWithoutReply() {
            if (this.mode === "clear") {
                return true;
            }
            if (this.mode === "ack") {
                return false;
            }
            return this.report && this.report.approval_followup === "awaiting_reply";
        },
        dialogTitle() {
            return this.isClearWithoutReply ? "Зняти примітку" : "Підтвердження";
        },
        dialogText() {
            if (this.isClearWithoutReply) {
                return "Ріелтор ще не відповів на коментар. Зняти примітку зі звіту?";
            }
            return "Ріелтор відповів на коментар. Підтвердіть, що все донесено — додатковий коментар не потрібен.";
        },
        confirmLabel() {
            return this.isClearWithoutReply ? "Зняти примітку" : "Підтвердити";
        },
    },
    watch: {
        isShowDialog(val) {
            this.isShow = val;
        },
        isShow(val) {
            if (!val) {
                this.$emit("closeDialog");
            }
        },
    },
    methods: {
        ...mapActions({
            setReport: "ReportsModule/setReport",
            setEvents: "EventsModule/setEvents",
            incrementSpinnerCounter: "SpinnerModule/incrementSpinnerCounter",
            decrementSpinnerCounter: "SpinnerModule/decrementSpinnerCounter",
        }),
        closeDialog() {
            this.$emit("closeDialog");
        },
        getEvents() {
            return this.axios.get("reminder").then((response) => {
                this.setEvents(response.data);
            }).catch(() => {});
        },
        confirm() {
            if (!this.targetReportId) {
                return;
            }

            this.isSaving = true;
            this.incrementSpinnerCounter();

            this.axios
                .post(`/reports/${this.targetReportId}/ack-followup`)
                .then((response) => {
                    const reportData = response.data.data;
                    if (reportData) {
                        if (!this.report || this.report.id === reportData.id) {
                            this.setReport(reportData);
                        }
                        this.eventHub.$emit("reportUpdated", reportData);
                    }
                    this.$emit("acked", reportData);
                    this.closeDialog();
                    this.eventHub.$emit(
                        "doShowSnackbarEvent",
                        true,
                        response.data.message || "Підтверджено",
                        "success",
                        3000
                    );
                    this.getEvents();
                })
                .catch((error) => {
                    this.eventHub.$emit(
                        "doShowSnackbarEvent",
                        true,
                        error.data?.message || "Помилка підтвердження",
                        "error",
                        5000
                    );
                })
                .finally(() => {
                    this.isSaving = false;
                    this.decrementSpinnerCounter();
                });
        },
    },
};
</script>

<style scoped lang="scss">
.v-btn {
    min-width: 150px !important;
}
</style>
